/* eslint-disable import/no-extraneous-dependencies */
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.REACT_APP_INSIGHTS_INSTRUMENTATION_KEY,
    connectionString: process.env.REACT_APP_INSIGHTS_CONNECTION_STRING,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});

appInsights.loadAppInsights();

appInsights.addTelemetryInitializer((envelope) => {
  if (envelope.tags?.["ai.user.id"]) {
    // eslint-disable-next-line no-param-reassign
    envelope.tags["ai.user.id"] = envelope.tags["ai.user.id"].replace(
      "AuthId",
      "Member Id",
    );
  }
});

export { reactPlugin, appInsights, browserHistory };
